import SearchWindow from './SearchWindow';

export default SearchWindow;